import { getOSSSignature as getOSSSignatureService, uploadFile as uploadFileService, uploadFileServiceUrl } from '@/service/file'
import cloneDeep from 'loadsh/cloneDeep'
import { getRandomString } from '@/utils'
import axios from 'axios'

const FILE_UPLOAD_STATUS = {
  SUCCESS: '',
  UPLOADING: 'uploading',
  FAILED: 'failed',
}

const FILE_UPLOAD_TYPE = {
  OSS: 'oss',
}

const uploadFile = {
  // 获取OSS签名
  getOSSSignatureService: function () {
    return getOSSSignatureService()
  },

  // 后台上传api
  uploadFileService: function () {
    return uploadFileService()
  },

  // 成功获取OSS签名则使用OSS上传，否则使用后台api上传
  getUploadFileOSSList: function (fileList) {
    const OSSList = []
    return this.getOSSSignatureService().then(res => {
      if (res && res.upType === FILE_UPLOAD_TYPE.OSS) {
         fileList.forEach(file => {
           let OSS = {}
           const randomStr = getRandomString()
           file.uid = randomStr
           file.url = res.host + '/' + res.dir + '/' + randomStr + file.name.replace(/ /g,'')
           OSS.policy = res.policy
           OSS.signature = res.signature
           OSS.ossAccessKeyId = res.accessid
           OSS.key = res.dir + '/' + randomStr + file.name.replace(/ /g,'')
           OSS.dir = res.dir
           OSS.host = res.host
           OSS.uid = randomStr
           OSS.url = res.host + '/' + res.dir + '/' + randomStr + file.name.replace(/ /g,'')
           OSS.file = file.file || file
           OSSList.push(cloneDeep(OSS))
         })
      } else {
        throw new Error();
      }
      return OSSList
    }).catch((err) => {
      fileList.forEach(file => {
        let OSS = {}
        const randomStr = getRandomString()
        file.url = ''
        file.uid = randomStr
        OSS.host = uploadFileServiceUrl
        OSS.surveyId = file.surveyId
        OSS.url = ''
        OSS.uid = randomStr
        OSS.file = file.file || file
        OSSList.push(cloneDeep(OSS))
      })
      return OSSList
    })
  },

  // 文件上传
  uploadFile:function (fileList, vm, callback) {
    this.getUploadFileOSSList(fileList).then(OSSList => {
      // 上传中状态
      fileList.forEach(file => {
        file.status = FILE_UPLOAD_STATUS.UPLOADING
        file.message = vm.cvtLang && vm.cvtLang('tipsUploading', vm.config.tipsUploading)
      })

      OSSList.forEach(OSS => {
        let formData = new FormData()
        for (let OSSKey in OSS) {
          formData.append(OSSKey, OSS[OSSKey])
        }

        axios({
          method: 'post',
          url: OSS.host,
          headers: {
            'Content-Type': 'application/octet-stream'
          },
          data: formData
        }).then((res) => {
          const targetFile = fileList.find(file => file.uid === OSS.uid)
          if ((res.data && res.data.code === 200) || (res.status && res.status === 204)) {
            // 上传成功
            if (targetFile) {
              targetFile.status = FILE_UPLOAD_STATUS.SUCCESS
              targetFile.message = ''

              if (!targetFile.url) {
                targetFile.url = res.data.data.url
              }
              callback(targetFile)
            }
          } else {
            // 上传失败
            if (targetFile) {
              targetFile.status = FILE_UPLOAD_STATUS.FAILED
              targetFile.message = vm.cvtLang && vm.cvtLang('tipsUploadFailed', vm.surveyInfoLang.tipsUploadFailed)
              callback(targetFile)
            }
          }
        }).catch(err => {
          const targetFile = fileList.find(file => file.uid === OSS.uid)

          // 上传失败
          if (targetFile) {
            targetFile.status = FILE_UPLOAD_STATUS.FAILED
            targetFile.message = vm.cvtLang && vm.cvtLang('tipsUploadFailed', vm.surveyInfoLang.tipsUploadFailed)
            callback(targetFile)
          }
        })
      })
    })
  }
}

export default uploadFile



// WEBPACK FOOTER //
// ./src/components/editor/UploadFileBox/uploadFile.js